<template>
  <b-col class="c306">
    <b-row>

      <b-col cols="6" class="p-0 px-2 m-0">
        <img :src="image" :alt="alt" class="p-0 m-0 mt-n5 c306-image w-100">
      </b-col>
      <b-col cols="5" class="p-0 m-0 c306-text-section">
        <div class="p-2">
          <slot name="p-1"/>
        </div>
      </b-col>
      <b-col cols="1" class="p-0 m-0">
        <div class="position-absolute c306-button-section">
          <slot name="p-2"/>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: "C306",
  props: {
    image: {
      default: 'https://picsum.photos/200/300'
    },
    alt: {
      default: 'mix it web'
    }
  }
}
</script>

<style scoped>
.c306-image {
  min-height: 165px;
  max-height: 165px;
  object-fit: contain;
}

.c306-button-section {
  bottom: 0
}


</style>